export const AVORIAZ_ANIMATION_DURATION = 700;
